import { sortNullValues } from "@/mixins/common";
import { APP_LOCALE } from "./locale";

/** numeric: true so "Mimbox 2" sorts before "Mimbox 10". */
const COLLATOR = new Intl.Collator(APP_LOCALE, { numeric: true });

/**
 * Locale-aware, null-safe string comparison.
 *
 * Nullish values sort last, matching the ordering the rest of the app uses via
 * sortNullValues.
 */

export function stringTrimStart(maybeString?: string | null): string | undefined | null {
  if (!maybeString) return maybeString;
  if (typeof maybeString != "string") return maybeString;
  return maybeString.trim().replace(/^(\d|\()+/g, "");
}
export function compareText(a?: string | null, b?: string | null): number {
  const nulls = sortNullValues(a, b);
  if (nulls !== null) return nulls;
  return COLLATOR.compare(stringTrimStart(a)!, stringTrimStart(b)!);
}

/** The shared collator, for callers that need more than compare(). */
export function getCollator(): Intl.Collator {
  return COLLATOR;
}

/** The locale sorting actually resolves to. Useful for diagnostics. */
export function activeTextLocale(): string {
  return COLLATOR.resolvedOptions().locale;
}
